import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import { getWidth } from '@components/styles';

import Counter from '@components/counter';
import Flex from '@components/layout/flex';
import Button from '@components/actions/button';
import Typography from '@components/basics/typography';
import RightArrow from '@components/basics/icons/right-arrow';

import LoadingCtrl from '@webapp/controllers/loading';

interface ButtonCounterProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  current: number;
  max: number;
  customMax?: number;
  disabled?: boolean;
  isLoading?: boolean;
  disableLoader?: boolean;
}

const ButtonCounter: FunctionComponent<ButtonCounterProps> = ({
  className,
  current,
  max,
  customMax,
  disabled,
  children,
  isLoading,
  disableLoader,
  onClick,
}) => {
  return (
    <Button
      className={className || ''}
      buttonType="primary"
      disabled={disabled}
      onClick={onClick}
      customContent={
        !isLoading ? (
          <Flex alignItems="center" justifyContent="space-between" gap={16}>
            <Counter
              monochrome
              disabled={disabled}
              customSize={38}
              current={current}
              max={max}
              customMax={customMax}
            />
            <Flex justifyContent="flex-end" alignItems="center" gap={10}>
              <Typography className={`text ${disabled ? 'disabled' : ''}`}>
                {children}
              </Typography>
              <RightArrow
                className={`arrow ${disabled ? 'disabled' : ''}`}
                isWhite
              />
            </Flex>
          </Flex>
        ) : disableLoader ? null : (
          <LoadingCtrl
            className={`loading-animation ${isLoading ? 'is-loading' : ''}`}
            loading={isLoading}
            isSVG
          />
        )
      }
    />
  );
};

export default styled(ButtonCounter)`
  max-height: none;
  position: relative;
  min-width: ${getWidth(5)};

  .text {
    color: ${({ theme }) => theme.colors.white};
    &.disabled {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }

  .arrow {
    &.disabled {
      path {
        fill: ${({ theme }) => theme.colors.tertiary};
      }
    }
  }

  .loading-animation {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    opacity: 0;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &.is-loading {
      opacity: 1;
    }

    svg {
      path {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;
